import ErrorBoundary from '@shared/components/ErrorBoundaries/ErrorBoundary';
import LayoutContainer, { LayoutBodyType } from '@shared/components/Layout/LayoutContainer';
import SecureMsalRoute from '@shared/components/SecureMsalRoute/SecureMsalRoute';
import useAuthService from '@shared/hooks/useAuthService';
import importRemote from '@shared/utilities/federation/loadremote';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';

const VDPRemote = React.lazy(() =>
    importRemote({
        remoteName: 'VDP',
        scope: 'remote_vdp',
        module: 'PhotoSurvey',
        remoteUrlLocation: process.env.REMOTE_VDP,
    })
);

const VDPPhotoSurvey = () => {
    const { stockNum, exifTag } = useParams();
    const { authService } = useAuthService();

    return (
        <>
            <Helmet>
                <title>Photo Quality Survey</title>
            </Helmet>
            <LayoutContainer
                minimizedHeader={<></>}
                layoutType={LayoutBodyType.Default}
                hideSubHeader
                hideBanner>
                <ErrorBoundary>
                    <SecureMsalRoute>
                        <VDPRemote
                            stockNum={stockNum}
                            exifTag={exifTag}
                            authService={authService}
                        />
                    </SecureMsalRoute>
                </ErrorBoundary>
            </LayoutContainer>
        </>
    );
};

export default VDPPhotoSurvey;
